import {
  COMMUNITY_HOSTNAME_PROD,
  COMMUNITY_HOSTNAME_TEST,
  COMMUNITY_SERVICE_HOST_NAME,
  CHATBOT_AUTH_URL_PROD,
  CHATBOT_AUTH_URL_TEST,
  DMS_PROPERTY_HOST_NAME,
  DOCUMENT_HOST_NAME_PROD,
  DOCUMENT_HOST_NAME_TEST,
  ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_PROD,
  ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_TEST,
  ICERIDGE_REQUEST_SERVICE_HOST_NAME_PROD,
  ICERIDGE_REQUEST_SERVICE_HOST_NAME_TEST,
  NOTIFICATIONS_HOST_NAME_PROD,
  NOTIFICATIONS_HOST_NAME_TEST,
  PAYMENT_HOST_NAME_PROD,
  PAYMENT_HOST_NAME_TEST,
  PROPERTIES_SEARCH_HOST_NAME_PROD,
  PROPERTIES_SEARCH_HOST_NAME_TEST,
  PROPERTY_HOST_NAME_PROD,
  PROPERTY_HOST_NAME_TEST,
  SALES_JOURNEY_HOST_NAME_PROD,
  SALES_JOURNEY_HOST_NAME_TEST,
  SERVICE_REQUEST_HOST_NAME_PROD,
  SERVICE_REQUEST_HOST_NAME_TEST,
  USER_HOST_NAME_PROD,
  USER_HOST_NAME_TEST,
  ASSETS_LOCATION_URL_PROD,
  ASSETS_LOCATION_URL_TEST,
  DOCUMENT_HOST_NAME_TEST_V2,
  DOCUMENT_HOST_NAME_PROD_V2,
  COMMON_HOST_NAME_TEST,
  COMMON_HOST_NAME_PROD,
  BLOB_STORAGE_HOST_NAME_TEST,
  BLOB_STORAGE_HOST_NAME_PROD,
  API_VERSIONS,
  SEARCH_HOST_NAME_TEST,
  SEARCH_HOST_NAME_PROD,
  GET_APPOINTMENT_AVAILABLE_SLOTS_ENDPOINT,
  COMMON_NOFICATION_HOST_NAME_TEST,
  COMMON_NOFICATION_HOST_NAME_PROD,
  USER_PROFILE_HOST_NAME_TEST,
  USER_PROFILE_HOST_NAME_PROD,
} from "./constants";
export const URLS: any = {
  GET_USER_DETAILS: {
    test: `${USER_HOST_NAME_TEST}user`,
    prod: `${USER_HOST_NAME_PROD}user`,
  },
  NEWS_EVENTS: {
    test: `${USER_HOST_NAME_TEST}newsAndEvents`,
    prod: `${USER_HOST_NAME_PROD}newsAndEvents`,
  },
  NEWS_DETAILS: {
    test: `${USER_HOST_NAME_TEST}newsDetails`,
    prod: `${USER_HOST_NAME_PROD}newsDetails`,
  },
  NEWS_LISTING: {
    test: `${USER_HOST_NAME_TEST}newsListing`,
    prod: `${USER_HOST_NAME_PROD}newsListing`,
  },
  COMMUNITY_UPDATE: {
    test: `${USER_HOST_NAME_TEST}communityUpdate`,
    prod: `${USER_HOST_NAME_PROD}communityUpdate`,
  },
  COMMUNITY_HIGHLIGHTS: {
    test: `${USER_HOST_NAME_TEST}communityHighlights`,
    prod: `${USER_HOST_NAME_PROD}communityHighlights`,
  },
  CONSTRUCTION_UPDATE: {
    test: `${PROPERTY_HOST_NAME_PROD}project/updates/construction`,
    prod: `${PROPERTY_HOST_NAME_TEST}project/updates/construction`,
  },
  HOME_CONTENT: {
    test: `${USER_HOST_NAME_TEST}home`,
    prod: `${USER_HOST_NAME_PROD}home`,
  },
  VALIDATE_MOBILE_EMAIL: {
    test: `${USER_HOST_NAME_TEST}user/validateMobileEmail`,
    prod: `${USER_HOST_NAME_PROD}user/validateMobileEmail`,
  },
  FAQ: {
    test: `${USER_HOST_NAME_TEST}faq`,
    prod: `${USER_HOST_NAME_PROD}faq`,
  },
  UPDATE_USER_DETAILS: {
    test: `${USER_HOST_NAME_TEST}updateProfile`,
    prod: `${USER_HOST_NAME_PROD}updateProfile`,
  },
  GLOBAL_CONFIG: {
    test: `${USER_HOST_NAME_TEST}configurations`,
    prod: `${USER_HOST_NAME_PROD}configurations`,
  },
  CITY_LIST_CONFIG: {
    test: `${DMS_PROPERTY_HOST_NAME}properties/feature/lead-meta`,
    prod: `${DMS_PROPERTY_HOST_NAME}properties/feature/lead-meta`,
  },
  UPLOAD_DOCUMENT: {
    test: `${DOCUMENT_HOST_NAME_TEST}document`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document`,
  },
  GLOBAL_SEARCH: {
    test: `${USER_HOST_NAME_TEST}globalSearch`,
    prod: `${USER_HOST_NAME_PROD}globalSearch`,
  },
  DOCUSIGN: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/signature`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/signature`,
  },
  UPDATE_DOCUSIGN: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/updateDocusign`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/updateDocusign`,
  },
  SERVICE_REQUEST_SEARCH: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/search`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/search`,
  },
  SERVICE_REQUEST_ELIGIBILITY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequestEligibility`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequestEligibility`,
  },
  PAYMENT_RECEIPT: {
    test: `${PAYMENT_HOST_NAME_TEST}generateReceipt`,
    prod: `${PAYMENT_HOST_NAME_PROD}generateReceipt`,
  },
  LEAN_CUSTOMER: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/customer`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/customer`,
  },
  BANK_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/bank-details`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/bank-details`,
  },
  DESTINATION_BANK: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/destinations/create`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/destinations/create`,
  },
  LEAN_PAYMENT: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/intent/create`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/intent/create`,
  },
  LEAN_PAYMENT_STATUS: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/intent/status/update`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/intent/status/update`,
  },
  LEAN_PAYMENT_COMPLETION_STATUS: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/intent/status`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/intent/status`,
  },
  LEAN_BANKS: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/banks`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/banks`,
  },
  SERVICE_REQUEST_CREATION: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequestCreate`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequestCreate`,
  },
  CUSTOMER_MANAGMENT_FEE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/customerMgmtFee`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/customerMgmtFee`,
  },
  CUSTOMER_MANAGMENT_FEE_STATUS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/customerMgmtFee/status`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/customerMgmtFee/status`,
  },
  FINANCIAL_STATEMENTS: {
    test: `${PAYMENT_HOST_NAME_TEST}financialStatement`,
    prod: `${PAYMENT_HOST_NAME_PROD}financialStatement`,
  },
  DOCUMENTS_BY_CUSTOMER_ID: {
    test: `${DOCUMENT_HOST_NAME_TEST}customerDocument`,
    prod: `${DOCUMENT_HOST_NAME_PROD}customerDocument`,
  },
  DOCUMENTS_BY_DOCUMENT_ID: {
    test: `${DOCUMENT_HOST_NAME_TEST}customerDocumentData`,
    prod: `${DOCUMENT_HOST_NAME_PROD}customerDocumentData`,
  },
  PROPERTY_JOURNEY_STEPS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/propertyjourney`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/propertyjourney`,
  },
  PROPERTY_JOURNEYS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/propertyjourneys`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/propertyjourneys`,
  },
  PROJECT_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}project/details`,
    prod: `${PROPERTY_HOST_NAME_PROD}project/details`,
  },
  NOTIFICATIONS_HISTORY: {
    test: `${NOTIFICATIONS_HOST_NAME_TEST}notification/history`,
    prod: `${NOTIFICATIONS_HOST_NAME_PROD}notification/history`,
  },
  GLOBAL_NOTIFICATIONS: {
    test: `${COMMON_NOFICATION_HOST_NAME_TEST}${API_VERSIONS.V1}/notification/history`,
    prod: `${COMMON_NOFICATION_HOST_NAME_PROD}${API_VERSIONS.V1}/notification/history`,
  },
  READ_GLOBAL_NOTIFICATIONS: {
    test: `${COMMON_NOFICATION_HOST_NAME_TEST}${API_VERSIONS.V1}/notification/action/read`,
    prod: `${COMMON_NOFICATION_HOST_NAME_PROD}${API_VERSIONS.V1}/notification/action/read`,
  },
  SAVE_DEVICE_DETAILS: {
    test: `${NOTIFICATIONS_HOST_NAME_TEST}notification/savedevice`,
    prod: `${NOTIFICATIONS_HOST_NAME_PROD}notification/savedevice`,
  },
  READ_NOTIFICATIONS: {
    test: `${NOTIFICATIONS_HOST_NAME_TEST}notification/read`,
    prod: `${NOTIFICATIONS_HOST_NAME_PROD}notification/read`,
  },
  SET_REMINDER: {
    test: `${NOTIFICATIONS_HOST_NAME_TEST}setReminder`,
    prod: `${NOTIFICATIONS_HOST_NAME_PROD}setReminder`,
  },
  SALES_ORDER_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}salesOrderDetails`,
    prod: `${PROPERTY_HOST_NAME_PROD}salesOrderDetails`,
  },
  CREATE_PAYMENT: {
    test: `${PAYMENT_HOST_NAME_TEST}createPayment`,
    prod: `${PAYMENT_HOST_NAME_PROD}createPayment`,
  },
  LEAD_VERIFY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lead/verify`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lead/verify`,
  },
  LEAD_CONVERT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lead/convert`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lead/convert`,
  },
  LEAD_UPDATE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lead/update`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lead/update`,
  },
  LEAD_CREATE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lead/create`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lead/create`,
  },
  LEAD_ELIGIBILITY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lead/eligibility`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lead/eligibility`,
  },
  GET_SALES_MANAGER_LIST: {
    test: `${USER_HOST_NAME_TEST}user/salesManager`,
    prod: `${USER_HOST_NAME_PROD}user/salesManager`,
  },
  OPPORTUNITY_UPDATE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}opportunityUpdate`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}opportunityUpdate`,
  },
  OPPORTUNITY_VERIFY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}opportunityVerify`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}opportunityVerify`,
  },
  ACCOUNT_UPDATE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}accountUpdate`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}accountUpdate`,
  },
  VALIDATE_GOOGLE_CAPTCHA: {
    test: `${USER_HOST_NAME_TEST}verifyCaptcha`,
    prod: `${USER_HOST_NAME_PROD}verifyCaptcha`,
  },
  GET_APPOINTMENT_AVAILABLE_DATES: {
    test: `${PROPERTY_HOST_NAME_TEST}appointments/dates`,
    prod: `${PROPERTY_HOST_NAME_PROD}appointments/dates`,
  },
  GET_APPOINTMENT_AVAILABLE_SLOTS: {
    test: `${PROPERTY_HOST_NAME_TEST}appointments/slots`,
    prod: `${PROPERTY_HOST_NAME_PROD}appointments/slots`,
  },
  CREATE_UPDATE_APPOINTMENT: {
    test: `${PROPERTY_HOST_NAME_TEST}appointments/create`,
    prod: `${PROPERTY_HOST_NAME_PROD}appointments/create`,
  },
  CANCEL_APPOINTMENT: {
    test: `${PROPERTY_HOST_NAME_TEST}appointments/cancel`,
    prod: `${PROPERTY_HOST_NAME_PROD}appointments/cancel`,
  },
  GENERATE_SOA: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/generatesoa`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/generatesoa`,
  },
  PERFORMA_INVOICE: {
    test: `${PAYMENT_HOST_NAME_TEST}proformalInvoice`,
    prod: `${PAYMENT_HOST_NAME_PROD}proformalInvoice`,
  },
  PROJECT_IMAGES_SEARCH: {
    test: `${PROPERTIES_SEARCH_HOST_NAME_TEST}search/communities/ensemble-details`,
    prod: `${PROPERTIES_SEARCH_HOST_NAME_PROD}search/communities/ensemble-details`,
  },
  PAYMENT_SUCCESS: {
    test: `${PAYMENT_HOST_NAME_TEST}paymentSuccess`,
    prod: `${PAYMENT_HOST_NAME_PROD}paymentSuccess`,
  },
  PAYMENT_FAILURE: {
    test: `${PAYMENT_HOST_NAME_TEST}paymentFailure`,
    prod: `${PAYMENT_HOST_NAME_PROD}paymentFailure`,
  },
  EMPTY_PROPERTIES: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/empty`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/empty`,
  },
  SERVICE_REQUEST_CREATION_V2: {
    test: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_TEST}${ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_TEST}`,
    prod: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_PROD}${ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_PROD}`,
  },
   SERVICE_REQUEST_CASE_CREATION_V2: {
    test: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_TEST}/api/v2/serviceRequestCreate`,
    prod: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_PROD}/api/v2/serviceRequestCreate`,
  },
  SERVICE_REQUEST_ELIGIBILITY_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/eligibility`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/eligibility`,
  },
  SERVICE_REQUESTS_CATALOGUE_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}catalogue/list`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}catalogue/list`,
  },
  SERVICE_REQUEST_UPLOAD_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}fileUpload/uploadToAzure`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}fileUpload/uploadToAzure`,
  },
  SERVICE_REQUEST_APPOINTMENT_SLOTS_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/slots`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/slots`,
  },
  SERVICE_REQUEST_APPOINTMENT_SCHEDULE_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/schedule`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/schedule`,
  },
  SERVICE_REQUEST_LIVE_TRACKING_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}technician/liveTrack`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}technician/liveTrack`,
  },
  SERVICE_REQUEST_DETAILS_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/details`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/details`,
  },
  SERVICE_REQUEST_CANCEL_V2: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/cancel`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}serviceRequest/cancel`,
  },
  PAYMENT_DATA: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/unitInvoiceList`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/unitInvoiceList`,
  },
  STATEMENTS_DATA: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/paymentHistory`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/paymentHistory`,
  },
  SERVICE_FEE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/totalServiceChargeDue`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/totalServiceChargeDue`,
  },
  PAYMENT_STATUS_DETAILS: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/transactions`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/transactions`,
  },
  CREATE_SERVICE_FEE_ENDPOINT: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/createPayment`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/createPayment`,
  },
  SERVICE_FEE_PAYMENT_SUCCESS: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/paymentSuccess`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/paymentSuccess`,
  },
  SERVICE_FEE_PAYMENT_FAILURE: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/paymentFailure`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/paymentFailure`,
  },
  UPDATE_SERVICE_FEE_PAYMENT: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/updatePayment`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/updatePayment`,
  },
  STATEMENT_SERVICE_CHARGE_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/paymentDetails`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/paymentDetails`,
  },
  SERVICE_FEE_FILTER_OPTIONS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/paymentFilters`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/paymentFilters`,
  },
  SERVICE_FEE_STATEMENT_DETAILS_PDF: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/receipt`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/receipt`,
  },
  SERVICE_FEE_PAYMENT_SUMMARY_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}service-charge/paymentSummary`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}service-charge/paymentSummary`,
  },
  DARNAPOINT_DETAILS: {
    test: `${USER_HOST_NAME_TEST}user/darna-details`,
    prod: `${USER_HOST_NAME_PROD}user/darna-details`,
  },
  NOC_INFO_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/estimate`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/estimate`,
  },
  NOC_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/tasks/status`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/tasks/status`,
  },
  OA_PENDING_CHARGES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/oa/pendingFee`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/oa/pendingFee`,
  },
  OA_BUYER_INFO_ENDPOINT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/buyerInfo/add`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/buyerInfo/add`,
  },
  NOC_DOCUMENT_UPLOAD: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/document`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/document`,
  },
  GET_BUYER_INFORMATION: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/`,
  },
  GET_BUYER_DOCU_SIGN_ID: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/docStatus`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/docStatus`,
  },
  GET_SR_ID: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/serviceRequest`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/serviceRequest`,
  },
  GET_NOC_CERTICATE_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/`,
  },
  UPDATE_NOC_JOURNEY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/tasks/update`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/tasks/update`,
  },
  GET_NOC_STEPS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/tasks`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/tasks`,
  },
  GET_NOC_FEE_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/tasks`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/tasks`,
  },
  SALES_JOURNEY_PROJECT_LIST: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/project/list`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/project/list`,
  },
  SALES_JOURNEY_ENDPOINT_GENERATOR: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/woa/endpoint/generator`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/woa/endpoint/generator`,
  },
  POST_GUEST_INFO: {
    test: `${COMMUNITY_SERVICE_HOST_NAME}visitor/register`,
    prod: `${COMMUNITY_SERVICE_HOST_NAME}visitor/register`,
  },
  SERVICE_REQUEST_GET_CATALOGUE_AMC_LIST: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}catalogue/amc/list`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}catalogue/amc/list`,
  },
  SERVICE_REQUEST_CONFIG_V2: {
    test: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_TEST}/api/v2/serviceRequest/config`,
    prod: `${ICERIDGE_REQUEST_SERVICE_HOST_NAME_PROD}/api/v2/serviceRequest/config`,
  },
  SERVICE_ENDPOINT_REOPEN_ENDPOINT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/reopen`,
    prod: `${SERVICE_REQUEST_HOST_NAME_TEST}serviceRequest/reopen`,
  },
  SPA_PASSPORT_UPLOAD: {
    test: `${DOCUMENT_HOST_NAME_TEST}digital-spa/uploadpassport`,
    prod: `${DOCUMENT_HOST_NAME_PROD}digital-spa/uploadpassport`,
  },
  SPA_EMIRATES_ID_FRONT: {
    test: `${DOCUMENT_HOST_NAME_TEST}digital-spa/emiratesId/front`,
    prod: `${DOCUMENT_HOST_NAME_PROD}digital-spa/emiratesId/front`,
  },
  SPA_EMIRATES_ID_BACK: {
    test: `${DOCUMENT_HOST_NAME_TEST}digital-spa/emiratesId/back`,
    prod: `${DOCUMENT_HOST_NAME_PROD}digital-spa/emiratesId/back`,
  },
  SPA_SET_DETAILS: {
    test: `${DOCUMENT_HOST_NAME_TEST}digital-spa/setSPADetails`,
    prod: `${DOCUMENT_HOST_NAME_PROD}digital-spa/setSPADetails`,
  },
  SPA_UAEPASS_INFO: {
    test: `${USER_HOST_NAME_TEST}user/uaepass/info`,
    prod: `${USER_HOST_NAME_PROD}user/uaepass/info`,
  },
  ENCRYPTED_SYMMETRICK_KEY: {
    test: `${USER_HOST_NAME_TEST}user/secure-key`,
    prod: `${USER_HOST_NAME_PROD}user/secure-key`,
  },
  INVESTMENT_PORTFOLIO_PARAMS: {
    test: `${DOCUMENT_HOST_NAME_TEST}investment-portfolio/parameters`,
    prod: `${DOCUMENT_HOST_NAME_PROD}investment-portfolio/parameters`,
  },
  INVESTMENT_PORTFOLIO_GRAPH_DATA: {
    test: `${DOCUMENT_HOST_NAME_TEST}investment-portfolio/data`,
    prod: `${DOCUMENT_HOST_NAME_PROD}investment-portfolio/data`,
  },
  USER_PORTFOLIO_GRAPH_DATA: {
    test: `${DOCUMENT_HOST_NAME_TEST}investment-portfolio/user-portfolio`,
    prod: `${DOCUMENT_HOST_NAME_PROD}investment-portfolio/user-portfolio`,
  },

  GET_VISITORS_LIST_ENDPOINT: {
    test: `${COMMUNITY_SERVICE_HOST_NAME}visitor/all`,
    prod: `${COMMUNITY_SERVICE_HOST_NAME}visitor/all`,
  },
  GET_VISITOR_INFO: {
    test: `${COMMUNITY_SERVICE_HOST_NAME}visitor/validate`,
    prod: `${COMMUNITY_SERVICE_HOST_NAME}visitor/validate`,
  },
  GET_VISITOR_QR_CODE: {
    test: `${COMMUNITY_SERVICE_HOST_NAME}visitor/qr-code`,
    prod: `${COMMUNITY_SERVICE_HOST_NAME}visitor/qr-code`,
  },
  UNIT_DETAILS: {
    test: `${COMMUNITY_HOSTNAME_TEST}bookings/unitDetails`,
    prod: `${COMMUNITY_HOSTNAME_PROD}bookings/unitDetails`,
  },
  HOME_PAGE_DETAILS: {
    test: `${COMMUNITY_HOSTNAME_TEST}livin/home`,
    prod: `${COMMUNITY_HOSTNAME_PROD}livin/home`,
  },
  STRIPE_CREATE_PAYMENT_INTENT: {
    test: `${PAYMENT_HOST_NAME_TEST}stripe/payments/create-intent`,
    prod: `${PAYMENT_HOST_NAME_PROD}stripe/payments/create-intent`,
  },
  GET_STRIPE_DETAILS: {
    test: `${PAYMENT_HOST_NAME_TEST}stripe/accounts/search`,
    prod: `${PAYMENT_HOST_NAME_PROD}stripe/accounts/search`,
  },
  GET_FEATURE_FLAG: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/feature/flags`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/feature/flags`,
  },
  CONFIGURABLE_CONTENTS: {
    test: `${ASSETS_LOCATION_URL_TEST}data/staticContentMessages.json`,
    prod: `${ASSETS_LOCATION_URL_PROD}data/staticContentMessages.json`,
  },
  GENERATE_SOA_NEW: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/soa`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/soa`,
  },
  //Digital sales
  DIGITAl_SALES_UNIT_LOCKING: {
    test: `${PROPERTY_HOST_NAME_TEST}booking/unit/locking`,
    prod: `${PROPERTY_HOST_NAME_PROD}booking/unit/locking`,
  },
  DIGITAl_SALES_UNIT_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}booking/unit/details`,
    prod: `${PROPERTY_HOST_NAME_PROD}booking/unit/details`,
  },
  DIGITAl_SALES_PAYMENT_PLANS: {
    test: `${PROPERTY_HOST_NAME_TEST}booking/payment/plans`,
    prod: `${PROPERTY_HOST_NAME_PROD}booking/payment/plans`,
  },
  DIGITAl_SALES_PAYMENT_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}booking/payment/details`,
    prod: `${PROPERTY_HOST_NAME_PROD}booking/payment/details`,
  },
  PROPERTY_SEARCH_FILTERS: {
    test: `${PROPERTIES_SEARCH_HOST_NAME_TEST}search/property/filter`,
    prod: `${PROPERTIES_SEARCH_HOST_NAME_PROD}search/property/filter`,
  },
  PROPERTY_SEARCH_SUGGESTIONS: {
    test: `${PROPERTIES_SEARCH_HOST_NAME_TEST}search/property/suggestions`,
    prod: `${PROPERTIES_SEARCH_HOST_NAME_PROD}search/property/suggestions`,
  },
  PROPERTY_SEARCH: {
    test: `${PROPERTIES_SEARCH_HOST_NAME_TEST}search/property`,
    prod: `${PROPERTIES_SEARCH_HOST_NAME_PROD}search/property`,
  },
  PROPERTY_SEARCH_V2: {
    test: `${PROPERTIES_SEARCH_HOST_NAME_TEST}search/properties`,
    prod: `${PROPERTIES_SEARCH_HOST_NAME_PROD}search/properties`,
  },
  SALES_RECORDS: {
    test: `${PROPERTY_HOST_NAME_TEST}booking/sales/record`,
    prod: `${PROPERTY_HOST_NAME_PROD}booking/sales/record`,
  },
  DS_CUSTOMER_DOCUMENT: {
    test: `${DOCUMENT_HOST_NAME_TEST}customerDocument`,
    prod: `${DOCUMENT_HOST_NAME_PROD}customerDocument`,
  },
  CREATE_PAYMENT_NOC_SERVICE_CHARGES: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/createPaymentNocSc`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/createPaymentNocSc`,
  },
  SERVICE_FEE_PAYMENT_SUCCESS_NOC: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/paymentSuccessNocSc`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/paymentSuccessNocSc`,
  },
  SERVICE_FEE_PAYMENT_FAILURE_NOC: {
    test: `${PAYMENT_HOST_NAME_TEST}service-charge/paymentFailureNocSc`,
    prod: `${PAYMENT_HOST_NAME_PROD}service-charge/paymentFailureNocSc`,
  },
  AUTH_CHATBOT: {
    test: `${CHATBOT_AUTH_URL_TEST}authentication/user`,
    prod: `${CHATBOT_AUTH_URL_PROD}authentication/user`,
  },
  DOCUSIGN_V2: {
    test: `${DOCUMENT_HOST_NAME_TEST_V2}document/signature`,
    prod: `${DOCUMENT_HOST_NAME_PROD_V2}document/signature`,
  },
  SPA_SET_DETAILS_V2: {
    test: `${DOCUMENT_HOST_NAME_TEST_V2}digital-spa/setSPADetails`,
    prod: `${DOCUMENT_HOST_NAME_PROD_V2}digital-spa/setSPADetails`,
  },
  USER_PORTFOLIO_GRAPH: {
    test: `${DOCUMENT_HOST_NAME_TEST}user-portfolio`,
    prod: `${DOCUMENT_HOST_NAME_PROD}user-portfolio`,
  },
  MARKET_TREND_FILTERS: {
    test: `${DOCUMENT_HOST_NAME_TEST}market-trend/filters`,
    prod: `${DOCUMENT_HOST_NAME_PROD}market-trend/filters`,
  },
  MARKET_TREND: {
    test: `${DOCUMENT_HOST_NAME_TEST}market-trend`,
    prod: `${DOCUMENT_HOST_NAME_PROD}market-trend`,
  },
  PROFILE_UPDATE_GENERATE_OTP: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/otp/generate`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/otp/generate`,
  },
  PROFILE_UPDATE_RESEND_OTP: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/otp/resend`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/otp/resend`,
  },
  PROFILE_UPDATE_VALIDATE_OTP: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/otp/validate`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/otp/validate`,
  },
  COMMON_ENCRYPTED_SYMMETRICK_KEY: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/encryption/secure-key`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/encryption/secure-key`,
  },
  EXTRACT_PASSPORT_DATA: {
    test: `${DOCUMENT_HOST_NAME_TEST}extract-passport-data`,
    prod: `${DOCUMENT_HOST_NAME_PROD}extract-passport-data`,
  },
  EXTRACT_EMIRATESID_DATA: {
    test: `${DOCUMENT_HOST_NAME_TEST}extract-emirates-data`,
    prod: `${DOCUMENT_HOST_NAME_PROD}extract-emirates-data`,
  },
  LIVINGIN_WIDGET_ENVIRONMENT_DATA: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/environmental-metrics/data`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/environmental-metrics/data`,
  },
  PREMIUM_PARKING_INVENTORY: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/inventory`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/inventory`,
  },
  PREMIUM_PARKING_ADDONS: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/products`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/products`,
  },
  PREMIUM_PARKING_ORDER_DETAILS: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/order/details`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/order/details`,
  },
  PREMIUM_PARKING_QUOTE_AND_LINES_ITEM: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/quote/list`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/quote/list`,
  },
  PREMIUM_PARKING_LEAD_CREATE: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/lead`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/lead`,
  },
  PREMIUM_PARKING_OPPORTUNITY: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/opportunity`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/opportunity`,
  },
  PREMIUM_PARKING_SAVE_QUOTE: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/quote/selection`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/quote/selection`,
  },
  PREMIUM_PARKING_QUOTE_AGREEMENT: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/quote/agreement`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/quote/agreement`,
  },
  PREMIUM_PARKING_PRODUCTS_CONTENT: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/products/content`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/products/content`,
  },
  PREMIUM_PARKING_PRODUCTS_COST: {
    test: `${SALES_JOURNEY_HOST_NAME_TEST}onu/prmpark/parking/product/cost`,
    prod: `${SALES_JOURNEY_HOST_NAME_PROD}onu/prmpark/parking/product/cost`,
  },
  CREATE_PARKING_PAYMENT: {
    test: `${PAYMENT_HOST_NAME_TEST}prmpark/payments/create`,
    prod: `${PAYMENT_HOST_NAME_PROD}prmpark/payments/create`,
  },
  PREMIUM_PAYMENT_SUCCESS: {
    test: `${PAYMENT_HOST_NAME_TEST}prmpark/payments/success`,
    prod: `${PAYMENT_HOST_NAME_PROD}prmpark/payments/success`,
  },
  PREMIUM_PAYMENT_FAILURE: {
    test: `${PAYMENT_HOST_NAME_TEST}prmpark/payments/failure`,
    prod: `${PAYMENT_HOST_NAME_PROD}prmpark/payments/failure`,
  },
  PARKING_ORDERS: {
    test: `${PROPERTY_HOST_NAME_TEST}prmpark/info/orders`,
    prod: `${PROPERTY_HOST_NAME_PROD}prmpark/info/orders`,
  },
  PARKING_PAYMENT_RECEIPT: {
    test: `${PAYMENT_HOST_NAME_TEST}prmpark/payments/stripe/payments/get-info`,
    prod: `${PAYMENT_HOST_NAME_PROD}prmpark/payments/stripe/payments/get-info`,
  },
  PARKING_SET_PREM_PARKING_DETAILS: {
    test: `${DOCUMENT_HOST_NAME_TEST}digital-spa/premium-parking/details`,
    prod: `${DOCUMENT_HOST_NAME_PROD}digital-spa/premium-parking/details`,
  },
  SERVICE_FEE_STATEMENT_DETAILS_PDF_NEW: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/service-charge/receipt/pdf`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/service-charge/receipt/pdf`,
  },
  SERVICE_CHARGES_SOA: {
    test: `${DOCUMENT_HOST_NAME_TEST}soa`,
    prod: `${DOCUMENT_HOST_NAME_PROD}soa`,
  },
  SERVICE_PDF_SOA_ENDPOINT:{
    test: `${DOCUMENT_HOST_NAME_TEST}soa/recipt/pdf`,
    prod: `${DOCUMENT_HOST_NAME_PROD}soa/recipt/pdf`,
  },
  CREATE_MOVE_IN: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveIn/create`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveIn/create`,
  },
  GET_MOVE_IN: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveIn/get`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveIn/get`,
  },
  CANCEL_MOVE_IN: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveIn/cancel`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveIn/cancel`,
  },
  GET_ELEVATOR_AVAILABLE_TIME_SLOTS: {
    test: `${COMMUNITY_HOSTNAME_TEST}/elevator/available-time-slots`,
    prod: `${COMMUNITY_HOSTNAME_PROD}/elevator/available-time-slots`,
  },
  //new property journey
  GET_PROPERTY_JOURNEY_DETAILS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/journey/details`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/journey/details`,
  },
  PROPERTY_JOURNEY_VIRTUAL_TOUR: {
    test: `${SEARCH_HOST_NAME_TEST}search/property`,
    prod: `${SEARCH_HOST_NAME_PROD}search/property`,
  },
  GET_APPOINTMENT_TIME_SLOTS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/candidates`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/candidates`,
  },
  CREATE_APPOINTMENT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/create`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/create`,
  },
  RESCHEDULE_APPOINTMENT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/reschedule`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/reschedule`,
  },
  GET_APPOINTMENT_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/handover`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/handover`,
  },
  CANCEL_SALES_ORDER: {
    test: `${PROPERTY_HOST_NAME_TEST}salesOrderCancellation`,
    prod: `${PROPERTY_HOST_NAME_PROD}salesOrderCancellation`,
  },
  HOME_ORIENTATION_FORM_OPTIONS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}appointment/form`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}appointment/form`,
  },
  DIGITAL_SALES_SKIP_FASTTRACK: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/skipFastrack`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/skipFastrack`,
  },
  FASTTRACK_KYB_OPTIONS: {
    test: `${ASSETS_LOCATION_URL_TEST}data/fasttrack-preference.json`,
    prod: `${ASSETS_LOCATION_URL_PROD}data/fasttrack-preference.json`,
  },
  FASTTRACK_SAVE_KYB_OPTIONS: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/preferences `,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/preferences `,
  },
  FASTTRACK_GET_KYB_OPTIONS: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/getPreferences `,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/getPreferences `,
  },
  DIGITAL_SALES_CREATE_FASTTRACK: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/createFastTrackRecord`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/createFastTrackRecord`,
  },
  DIGITAL_SALES_CREATE_CPRECORD: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/createCPRecord`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/createCPRecord`,
  },
  DIGITAL_SALES_GET_SALESMANAGERS: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/salesManagerDetails`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/salesManagerDetails`,
  },
  DIGITAL_SALES_UPDATE_SALESMANAGER: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/updateOpportunityOwner`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/updateOpportunityOwner`,
  },
  DIGITAL_SALES_UNIT_AVAILABILITY: {
    test: `${DOCUMENT_HOST_NAME_TEST}kyc/getUnitAvailability`,
    prod: `${DOCUMENT_HOST_NAME_PROD}kyc/getUnitAvailability`,
  },
  DIGITAL_SALES_SHORTLISTED_UNITS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/getShortlistedProperties`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/getShortlistedProperties`,
  },
  DIGITAL_SALES_SHORTLISTED_UNITS_V2: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/shortlisted`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/shortlisted`,
  },
  //lease journeys
  LEASE_JOURNEYS: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/leaseJourneys`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/leaseJourneys`,
  },
  COMMUNITIES_DETAILS: {
    test: `${COMMUNITY_HOSTNAME_TEST}rl/communities/details`,
    prod: `${COMMUNITY_HOSTNAME_PROD}rl/communities/details`,
  },
  COMMUNITY_FLAGS:{
    test: `${COMMUNITY_HOSTNAME_TEST}communities/flags`,
    prod: `${COMMUNITY_HOSTNAME_PROD}communities/flags`,
  },
  LEASE_INSTALLMENTS_TIMELINE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}livin/federated-search/timeline`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}livin/federated-search/timeline`,
  },
  PAYMENTS_FILTER_OPTIONS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}livin/federated-search/filters`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}livin/federated-search/filters`,
  },
  PAYMENTS_DATA: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}livin/federated-search/payments`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}livin/federated-search/payments`,
  },
  CREATE_MOVE_OUT: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveOut/create`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveOut/create`,
  },
  GET_MOVE_OUT: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveOut/get`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveOut/get`,
  },
  CANCEL_MOVE_OUT: {
    test: `${COMMUNITY_HOSTNAME_TEST}moveOut/cancel`,
    prod: `${COMMUNITY_HOSTNAME_PROD}moveOut/cancel`,
  },
  ECMS_DOC_SEARCH: {
    test: `${DOCUMENT_HOST_NAME_TEST}ecms/search`,
    prod: `${DOCUMENT_HOST_NAME_PROD}ecms/search`,
  },
  ECMS_PROPERTY_LIST_SUMMARY: {
    test: `${PROPERTY_HOST_NAME_TEST}properties/list/unit/summary`,
    prod: `${PROPERTY_HOST_NAME_PROD}properties/list/unit/summary`,
  },
  ECMS_GET_DOC_DOWNLOAD_URL: {
    test: `${DOCUMENT_HOST_NAME_TEST}ecms/download`,
    prod: `${DOCUMENT_HOST_NAME_PROD}ecms/download`,
  },
  GET_RECEIPT_PDF_ADMIN_FEE:{
    test: `${DOCUMENT_HOST_NAME_TEST}OAAdminFee/receipt/pdf`,
    prod: `${DOCUMENT_HOST_NAME_PROD}OAAdminFee/receipt/pdf`,
  },
  //Darna Points
  DARNA_POINTS_UPDATE: {
    test: `${USER_HOST_NAME_TEST}user/darna/points-update`,
    prod: `${USER_HOST_NAME_PROD}user/darna/points-update`,
  },
  DARNA_CONVERSION_RATES: {
    test: `${USER_HOST_NAME_TEST}user/darna/conversion-rates`,
    prod: `${USER_HOST_NAME_PROD}user/darna/conversion-rates`,
  },
  DARNA_PROFILE: {
    test: `${USER_HOST_NAME_TEST}user/darna/profile`,
    prod: `${USER_HOST_NAME_PROD}user/darna/profile`,
  },
  CREATE_GENERAL_SERVICES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}generalServices/create`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}generalServices/create`,
  },
  GET_GENERAL_SERVICES_SR_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}generalServices/get`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}generalServices/get`,
  },
  CANCEL_GENERAL_SERVICES_SR: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}generalServices/cancel`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}generalServices/cancel`,
  },
  GET_CASE_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}generalServices/sr/details`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}generalServices/sr/details`,
  },
  CREATE_TENANT_ONBOARDING: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}tenant/create`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}tenant/create`,
  },
  GET_TENANT_ONBOARDING_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}tenant/get`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}tenant/get`,
  },
  GET_TENANT_COMMUNITY_LIST: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}tenantSelfOnboarding/getCommunity`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}tenantSelfOnboarding/getCommunity`,
  },
  CREATE_TENANT_SELF_ONBOARDING_CASE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}tenantSelfOnboarding/createCase`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}tenantSelfOnboarding/createCase`,
  },
  ADD_OCCUPANT_MEMBER: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}occupant/add`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}occupant/add`,
  },
  GET_CONTRACT_EXPIRY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}tenantSelfOnboarding/checkContractExpiry`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}tenantSelfOnboarding/checkContractExpiry`,
  },
  // Lead-to-Lease
  LEASE_FEDERATED_UNITS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}livin/federated-search/units`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}livin/federated-search/units`,
  },
  LEASING_JOURNEY_STATUS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/journey-status`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/journey-status`,
  },
  LEASING_OFFER_ACKNOWLEDGEMENT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}lease/offer/acknowledgement`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}lease/offer/acknowledgement`,
  },
  DECLINE_REASON: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/offer/decline-reasons`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/offer/decline-reasons`,
  },
  CONSENT_CONTENT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/payments/consents/info`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/payments/consents/info`,
  },
  CONSENT_STATUS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/payments/consents`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/payments/consents`,
  },
  ACKNOWLEDGE_CONSENT: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/payments/consents/acknowledge`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/payments/consents/acknowledge`,
  },
  PAYMENT_LIFE_CYCLE: {
    test: `${PAYMENT_HOST_NAME_TEST}payment-lifecycle/status/payment-created/by-idempotency-key`,
    prod: `${PAYMENT_HOST_NAME_PROD}payment-lifecycle/status/payment-created/by-idempotency-key`,
  },
  SIGN_DOCUMENT: {
    test: `${DOCUMENT_HOST_NAME_TEST}lease/contract/sign-and-upload`,
    prod: `${DOCUMENT_HOST_NAME_PROD}lease/contract/sign-and-upload`,
  },
  SIGN_DOCUMENT_ENCRYPTED: {
    test: `${DOCUMENT_HOST_NAME_TEST_V2}lease/contract/sign-and-upload`,
    prod: `${DOCUMENT_HOST_NAME_PROD_V2}lease/contract/sign-and-upload`,
  },
  PAYMENT_CONSOLIDATED_RECEIPT: {
    test: `${DOCUMENT_HOST_NAME_TEST}lease/payments/receipt-pdf`,
    prod: `${DOCUMENT_HOST_NAME_PROD}lease/payments/receipt-pdf`,
  },
  LEAN_CONFIGURATION: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/config`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/config`,
  },
  ALTERNATIVE_UNITS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}leasing-journey/units/alternatives`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}leasing-journey/units/alternatives`,
  },
  PAYMENTS_CONTEXT: {
    test: `${PAYMENT_HOST_NAME_TEST}payment-context/eligibility`,
    prod: `${PAYMENT_HOST_NAME_PROD}payment-context/eligibility`,
  },
  LEAN_AOF_CONSENT: {
    test: `${PAYMENT_HOST_NAME_TEST}lean/consent/create`,
    prod: `${PAYMENT_HOST_NAME_PROD}lean/consent/create`,
  },
  PROPERTY_TRANSFER_GET_AGENCY_LIST: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}getBrokers`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}getBrokers`,
  },
  PROPERTY_TRANSFER_REQUEST_CREATE: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}create-property-transfer`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}create-property-transfer`,
  },
  PROPERTY_TRANSFER_GET_TRANSFERS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}property-transfers`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}property-transfers`,
  },
  PROPERTY_TRANSFER_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}get-property-transfer`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}get-property-transfer`,
  },
  PROPERTY_TRANSFER_BANK_LIST: {
    test: `${PAYMENT_HOST_NAME_TEST}direct-debit/bank-list`,
    prod: `${PAYMENT_HOST_NAME_PROD}direct-debit/bank-list`,
  },
  PROPERTY_TRANSFER_SET_BANK_DETAILS: {
    test: `${PAYMENT_HOST_NAME_TEST}direct-debit/bank-info`,
    prod: `${PAYMENT_HOST_NAME_PROD}direct-debit/bank-info`,
  },
  PROPERTY_TRANSFER_GET_TRANSFER_DOC: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/multi-signature`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/multi-signature`,
  },
  PROPERTY_TRANSFER_UPDATE_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}update-property-request`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}update-property-request`,
  },
  PROPERTY_TRANSFER_PDC_OPTIONS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}property/transfer/pdc`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}property/transfer/pdc`,
  },
  // Payment Link
  GET_PAYMENT_LINK_DETAILS: {
    test: `${PAYMENT_HOST_NAME_TEST}stripe/payment-links`,
    prod: `${PAYMENT_HOST_NAME_PROD}stripe/payment-links`,
  },
  CREATE_HANDOFF: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/handoff`,
    prod: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/handoff`,
  },
  GET_EOI_PROJECT_LIST: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}eoi/list`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}eoi/list`,
  },
  CREATE_UPDATE_EOI: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}eoi`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}eoi`,
  },
   //joint owners
  GET_CO_OWNER_DETAILS:{
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/list/jointowner`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/list/jointowner`,
  },
  GET_CO_OWNER_PENDING_ACTIONS:{
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/jointOwner/consent/status`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/jointOwner/consent/status`,
  },
   CREATE_JOINT_OWNER_NOC_SR: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/jointOwner/request/create`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/jointOwner/request/create`,
  },
  UPDATE_JOINT_OWNER_NOC_STATUS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/jointOwner/consent`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/jointOwner/consent`,
  },
   // Booking Classes
  BOOKING_CLASS_CATEGORIES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/categories`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/categories`,
  },
  BOOKING_CLASSES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}bookings/classes`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}bookings/classes`,
  },
  BOOKING_CLASS_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}bookings/class/details`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}bookings/class/details`,
  },
  BOOKING_PROVIDER_CLASSES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}bookings/provider/classes`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}bookings/provider/classes`,
  },
  CREATE_BOOKING: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/bookings`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/bookings`,
  },
  GET_BOOKING_PACKAGES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/packages`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/packages`,
  },
  GET_BOOKING_SCHEDULES: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/schedules`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/schedules`,
  },
  GET_BOOKING_AVAILABLE_SLOTS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/availableSlots`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/availableSlots`,
  },
  GET_BOOKING_HISTORY: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}classes/getBookings`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}classes/getBookings`,
  },
  GET_BOOKING_RECEIPT_PDF: {
    test: `${DOCUMENT_HOST_NAME_TEST}lease/document-receipt-pdf`,
    prod: `${DOCUMENT_HOST_NAME_PROD}lease/document-receipt-pdf`,
  },
  INITIATE_CLASS_PAYMENT: {
    test: `${PAYMENT_HOST_NAME_TEST}classes/initiate-payment`,
    prod: `${PAYMENT_HOST_NAME_PROD}classes/initiate-payment`,
  },
  BOOKING_FAQ: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}bookings/faq`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}bookings/faq`,
  },
  BOOKING_TERMS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}bookings/terms`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}bookings/terms`,
  },
  CANCEL_NOC_SR: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}noc/jointOwner/cancelSr`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}noc/jointOwner/cancelSr`,
  },
  GET_DOCUMENT_LIST: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/history`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/history`,
  },
  DELETE_DOCUMENT: {
    test: `${DOCUMENT_HOST_NAME_TEST}document/delete`,
    prod: `${DOCUMENT_HOST_NAME_PROD}document/delete`,
  },
  PAYMENTS_RECORDS: {
    test: `${DOCUMENT_HOST_NAME_TEST}lease/payment-record`,
    prod: `${DOCUMENT_HOST_NAME_PROD}lease/payment-record`,
  },
  BLOB_FILE_UPLOAD: {
    test: `${BLOB_STORAGE_HOST_NAME_TEST}api/v1/blob/fileupload`,
    prod: `${BLOB_STORAGE_HOST_NAME_PROD}api/v1/blob/fileupload`,
  },
  GET_USER_PROFILE_FULL: {
    test: `${USER_PROFILE_HOST_NAME_TEST}${API_VERSIONS.V2}/global/user/profile/full`,
    prod: `${USER_PROFILE_HOST_NAME_PROD}${API_VERSIONS.V2}/global/user/profile/full`,
  },
  GET_USER_RELATIONSHIPS: {
    test: `${USER_PROFILE_HOST_NAME_TEST}${API_VERSIONS.V1}/global/user/relationship`,
    prod: `${USER_PROFILE_HOST_NAME_PROD}${API_VERSIONS.V1}/global/user/relationship`,
  },
  REMOVE_OCCUPANT_RELATIONSHIP: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}occupant/relationship/remove`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}occupant/relationship/remove`,
  },
  GET_OCCUPANT_DETAILS: {
    test: `${SERVICE_REQUEST_HOST_NAME_TEST}occupant/details`,
    prod: `${SERVICE_REQUEST_HOST_NAME_PROD}occupant/details`,
  },
  PROMOTIONS_CAROUSELS: {
    test: `${COMMON_HOST_NAME_TEST}${API_VERSIONS.V1}/personas/permission`,
    prod: `${COMMON_HOST_NAME_PROD}${API_VERSIONS.V1}/personas/permission`,
  },
};

